const newOrRenewal = Object.freeze(['NEW', 'RENEWAL']);

export default newOrRenewal;
